export type StreamingMaxHeight = 480 | 720;

interface StreamingDevice {
  navigator?: { userAgent?: string; platform?: string; maxTouchPoints?: number };
  innerWidth?: number;
  matchMedia?: (query: string) => { matches: boolean };
}

/** Capture once per player lifetime; orientation changes must not raise the cap. */
export function preferredStreamingHeight(device?: StreamingDevice): StreamingMaxHeight {
  if (!device) { return 480; }
  const navigator = device.navigator || {};
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
  const desktopIpad = /Macintosh|MacIntel/i.test(`${navigator.userAgent || ''} ${navigator.platform || ''}`) &&
    (navigator.maxTouchPoints || 0) > 1;
  const coarse = device.matchMedia && device.matchMedia('(pointer: coarse)').matches;
  const narrow = device.innerWidth > 0 && device.innerWidth <= 768;
  return mobile || desktopIpad || coarse || narrow ? 480 : 720;
}

/** hls.js caps by index; stop before any oversized level, regardless of ordering. */
export function cappedAutoLevel(levels: ReadonlyArray<{ height?: number }>, maxHeight: StreamingMaxHeight): number {
  if (!levels.length) { return -1; }
  const firstTooHigh = levels.findIndex((level) => level.height > maxHeight);
  // Legacy sources with no fitting rendition can only use their lowest level;
  // the server-filtered PMU/Equidia ladders enforce the actual height guarantee.
  return firstTooHigh === -1 ? levels.length - 1 : Math.max(0, firstTooHigh - 1);
}
